// extracted by mini-css-extract-plugin
export default {"shalinaSelect":"dropdown_shalinaSelect__O-P-B","placeHolderText":"dropdown_placeHolderText__sehk7","selectIcon":"dropdown_selectIcon__PVVeL"};